
<template>
  <div>
    <Grid
      :service="service"
      defaultOrderColumn="created_date_formatted"
      defaultOrderDirection="asc"
      route_name="/portal-cebas/credentialings/handlings"
      :ref="'grid'"
      :css_formats="{
        validated_date_formatted: (status, model) => {
          if(status){
            return `badge badge-glow badge-${status.color}`
          }else{
            return ''
          }
        },
        status: (status, model) => {
          return `badge badge-glow badge-${status.color}`
        }
      }"
      :column_formats="{
        status: (val) => {
          return val.label
        }
      }"
      >
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="`portal_cebas.credentialing.handling`"
            icon="EditIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Tratar formulário',
              delay: { show: 100, hide: 100 }
            }"
            @click="handling(actions.row.id)"
          />
          <feather-icon
            v-permission="`portal_cebas.credentialing.handling.detail`"
            icon="EyeIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Detalhar registro',
              delay: { show: 100, hide: 100 }
            }"
            @click="detail(actions.row.id)"/>

          <feather-icon
            v-permission="`portal_cebas.credentialing.handling.delete`"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            v-tooltip.top="{
              content: 'Excluir registro',
              delay: { show: 100, hide: 100 }
            }"
            @click="destroy(actions.row.id)"/>
        </div>
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'

import CebasCredentialingHandlingService from '@/services/api/cebas/CebasCredentialingHandlingService'

export default {
  directives: {
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    grid() {
      return this.$refs['grid']
    },
    handling(id) {
      this.$router.push(`/portal-cebas/credentialings/handlings/${id}/handling`)
    },
    detail(id) {
      this.$router.push(`/portal-cebas/credentialings/handlings/${id}`)
    },
    destroyModel(id) {
      this.$vs.loading()
      this.service.destroy(id).then(
        response => {
          this.notifySuccess(this.$vs, 'Registro excluído com sucesso!')
          this.grid().fetchGridData()
        },
        error => {
          this.notifyError(this.$vs, 'Não foi possível excluir o registro especificado')
        }
      ).finally(
        () => this.$vs.loading.close()
      )
    },
    destroy(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.destroyModel(id)
        }
      })
    }
  },
  beforeMount() {
    this.service = CebasCredentialingHandlingService.build(this.$vs)
  }
}
</script>
